import type * as React from "react";
import { MoreHorizontal } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

interface RowMenuProps {
  label?: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  modal?: boolean;
}

/**
 * Compact table actions backed by the production shadcn DropdownMenu so focus,
 * dismissal, keyboard navigation, and portalling remain consistent everywhere.
 */
export function RowMenu({
  label = "Actions",
  children,
  className,
  disabled = false,
  modal = false,
}: RowMenuProps) {
  return (
    <DropdownMenu modal={modal}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm-touch"
          className={className}
          aria-label={label}
          disabled={disabled}
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

type RowMenuItemProps = React.ComponentProps<typeof DropdownMenuItem>;

export function RowMenuItem({
  className,
  children,
  ...rest
}: RowMenuItemProps) {
  return (
    <DropdownMenuItem className={cn("px-3 py-2", className)} {...rest}>
      {children}
    </DropdownMenuItem>
  );
}
